import React, { useEffect, useState } from 'react'
import AppDashboardTasksSummary from './AppDashboardTasksSummary'
// import AppDashboardTrendsSummary from './AppDashboardTrendsSummary'
// import AppDashboardAchievmentsSummary from './AppDashboardAchievmentsSummary'
import AppFutureEvents from './AppFutureEvents/AppFutureEvents.component'

import AppQuote from 'components/AppQuote/AppQuote.component'

import moment from 'moment'
import {
  CalendarEventViewPreference,
  useGetQuoteQuery,
  useUpdateMyProfileMutation,
} from '__generated__/api-types-and-hooks'
import { getTenantId } from 'utils/getTenantId'
import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'

import useGetUserProfile from 'components/AppDashboard/AppDashboard.hook'
import { RootState } from 'App'
import { AppDashboardHeader } from 'components/AppDashboard/AppDashboardHeader/AppDashboardHeader.component'
import { AppGoalStatsCard } from 'components/Common/AppGoalStatsCard/AppGoalStatsCard.component'
import { useUserDashboard } from 'appHooks/useUserDashboard'
import { AppDashboardGridItemWrapper } from './style'
import { AppToggleButton } from 'components/Common/AppToggleButton/AppToggleButton.component'
import { getRoleFromPath } from 'utils/helper'
import { ROLES } from 'config'
// import { AppButton } from 'components/Common/AppButton/AppButton.component'

import { AppStatsCard } from 'components/Common/AppStatsCard/AppStatsCard.component'
import { AppToolTip } from 'components/Common/AppToolTip/AppToolTip.component'
import { AppToolTipIcon } from 'components/Common/AppToolTip/AppToolTipIcon'

const AppDashboard = () => {
  const tenantId = getTenantId()
  const role = getRoleFromPath()
  const clientId = useSelector((state: RootState) => state.clients.client.profile.id)
  const [showQuoteModal, setShowQuoteModal] = useState(true)

  const { data } = useGetQuoteQuery()
  const getUserProfile = useGetUserProfile()
  const currentUser = useSelector((state: RootState) => state.user.user)
  const { mutate: updateUserProfile, isSuccess } = useUpdateMyProfileMutation()

  const currentDate = moment.tz(currentUser.timezone || 'America/Chicago').format('DD-MM-YYYY')
  const isSameDate = currentDate === currentUser.quoteViewDate || ''

  useEffect(() => {
    if (isSuccess) {
      getUserProfile()
    }
    // eslint-disable-next-line
  }, [isSuccess])

  const {
    goalStats,
    showInternalMeetingsOnly,
    handleToggle,

    // for stats
    statsData,
    periods,
    isRevenueLoading,
    isNetProfitLoading,
    isNumberOfLeadsLoading,
    isLeadsConversionRateLoading,
    isMetricsViewEnabled,
    handleMetricsShare,
    revenueMetricError,
    netProfitError,
    numberOfLeadsError,
    leadsConversionRateError,
    refetchRevenueMetrics,
    refetchNetProfitMetrics,
    refetchNumberOfLeadsMetrics,
    refetchLeadsConversionRateMetrics,
    businessNumberOfLeadsMetric,
    businessLeadsConversionRateMetric,
  } = useUserDashboard()

  // for stats
  const AppDashboardStatsSummary = () => {
    return (
      <div className="space-y-8">
        <div className="space-y-4 smd:space-y-0 smd:flex smd:items-center smd:justify-between">
          <h3 className="text-xl font-medium font-inter">Your Stats</h3>
          <div className="flex items-center justify-between">
            {/* Show for bso client view */}
            {!role?.includes(ROLES.BUSINESS_OWNER) ? (
              <div className="flex items-center space-x-8">
                {/* <AppButton
                  variant="primary"
                  size="sm"
                  label="Request access to veiw"
                  disabled={true}
                /> */}
                <div className="flex items-center space-x-2">
                  <h3 className="font-normal text-sm">View Only</h3>
                  <AppToolTip variant="primary" name={'views'} text={'You can only view'}>
                    <AppToolTipIcon />
                  </AppToolTip>
                </div>
              </div>
            ) : (
              // else show for bo view
              <div className="flex items-center space-x-8">
                <div className="flex items-center space-x-2">
                  <span className="font-normal text-sm">Share with consultant</span>
                  <AppToolTip
                    variant="primary"
                    name={'views'}
                    text={
                      'We recommend sharing your stats with your consultant, so they can better support you in meeting your goals.'
                    }
                  >
                    <AppToolTipIcon />
                  </AppToolTip>
                </div>
                <AppToggleButton
                  isToggled={isMetricsViewEnabled}
                  toggleButtonHandler={() => handleMetricsShare(!isMetricsViewEnabled)}
                  size="small"
                  showDefaultLabel={false}
                />
              </div>
            )}
            {/* <AppButton
                variant="secondary"
                size="md"
                label="Edit Stats"
                onClick={() => {}}
                /> */}
          </div>
        </div>
        <Stats />
      </div>
    )
  }

  const Stats = () => {
    // Check if data is actually unavailable for revenue
    // Show error state when main value is "---" (no data from database) and not loading
    const revenueDataUnavailable =
      !isRevenueLoading && statsData.totalRevenue.value === '---' && !revenueMetricError

    // Check if data is actually unavailable for net profit
    // Show error state when main value is "---" (no data from database) and not loading
    const netProfitDataUnavailable =
      !isNetProfitLoading && statsData.netProfit.value === '---' && !netProfitError

    // Check if data is actually unavailable (null) for number of leads
    const numberOfLeadsValue =
      businessNumberOfLeadsMetric?.getBusinessProfile?.leadCount?.counter?.value ?? null
    const numberOfLeadsDataUnavailable =
      !isNumberOfLeadsLoading && numberOfLeadsValue === null && !numberOfLeadsError

    // Check if data is actually unavailable (null) for lead conversion rate
    const leadConversionRateValue =
      businessLeadsConversionRateMetric?.getBusinessProfile?.leadConversionRate?.counter?.value ??
      null
    const leadConversionRateDataUnavailable =
      !isLeadsConversionRateLoading && leadConversionRateValue === null && !leadsConversionRateError

    return (
      <div className="space-y-12 mdl:space-y-0 mdl:flex mdl:items-center mdl:space-x-10">
        <AppDashboardGridItemWrapper>
          <AppStatsCard
            {...statsData.totalRevenue}
            period={periods.totalRevenuePeriod}
            onPeriodChange={periods.setTotalRevenuePeriod}
            isLoading={isRevenueLoading}
            hideMetric={!isMetricsViewEnabled && clientId}
            errorMessage={revenueMetricError || revenueDataUnavailable ? 'Data Not Available' : ''}
            errorMessageTooltip={
              revenueMetricError || revenueDataUnavailable ? 'Connect QuickBooks' : ''
            }
            onRetry={refetchRevenueMetrics}
          />
          <hr className="my-6 border border-app-grey-30" />
          <AppStatsCard
            {...statsData.netProfit}
            period={periods.netProfitPeriod}
            onPeriodChange={periods.setNetProfitPeriod}
            isLoading={isNetProfitLoading}
            hideMetric={!isMetricsViewEnabled && clientId}
            errorMessage={netProfitError || netProfitDataUnavailable ? 'Data Not Available' : ''}
            errorMessageTooltip={
              netProfitError || netProfitDataUnavailable ? 'Connect QuickBooks' : ''
            }
            onRetry={refetchNetProfitMetrics}
          />
        </AppDashboardGridItemWrapper>

        <AppDashboardGridItemWrapper>
          <AppStatsCard
            {...statsData.numberOfLeads}
            period={periods.numberOfLeadsPeriod}
            onPeriodChange={periods.setNumberOfLeadsPeriod}
            isLoading={isNumberOfLeadsLoading}
            hideMetric={!isMetricsViewEnabled && clientId}
            errorMessage={
              numberOfLeadsError || numberOfLeadsDataUnavailable ? 'Data Not Available' : ''
            }
            errorMessageTooltip={
              numberOfLeadsError || numberOfLeadsDataUnavailable ? 'Connect HubSpot' : ''
            }
            dataSources="All Channels"
            onRetry={refetchNumberOfLeadsMetrics}
          />
          <hr className="my-6 border border-app-grey-30" />
          <AppStatsCard
            {...statsData.leadConversionRate}
            period={periods.leadConversionRatePeriod}
            onPeriodChange={periods.setLeadConversionRatePeriod}
            isLoading={isLeadsConversionRateLoading}
            hideMetric={!isMetricsViewEnabled && clientId}
            errorMessage={
              leadsConversionRateError || leadConversionRateDataUnavailable
                ? 'Data Not Available'
                : ''
            }
            errorMessageTooltip={
              leadsConversionRateError || leadConversionRateDataUnavailable ? 'Connect HubSpot' : ''
            }
            dataSources="All Channels"
            onRetry={refetchLeadsConversionRateMetrics}
          />
        </AppDashboardGridItemWrapper>
      </div>
    )
  }

  return (
    <div className="w-full space-y-12 px-4 py-8 mdl:py-0 mdl:px-0">
      {showQuoteModal && !isSameDate && !isEmpty(data?.getQuote) && (
        <AppQuote
          onClose={() => {
            updateUserProfile({
              input: {
                userId: currentUser.id,
                tenantId,
                quoteViewDate: currentDate.toString(),
              },
            })
            setShowQuoteModal(false)
          }}
          quote={data?.getQuote?.quote || ''}
          author={data?.getQuote?.author || ''}
          currentDay={currentDate.split('-')[0]}
        />
      )}
      {!clientId && (
        <AppDashboardHeader
          userName={`${currentUser.firstName}`}
          activatedAt={currentUser.activatedAt}
        />
      )}

      {/* stats carousel */}
      <div className="mt-8">
        <AppGoalStatsCard stats={goalStats} />
      </div>
      <div className="space-y-12 mdl:space-y-0 mdl:flex mdl:items-center mdl:space-x-10">
        <AppDashboardTasksSummary />
        <AppDashboardGridItemWrapper>
          {role?.includes(ROLES.BUSINESS_OWNER) && (
            <div>
              <div className="flex items-center gap-2">
                <h3 className="text-xl font-normal font-inter">Upcoming Appointments</h3>
                <h3 className="text-xl font-normal text-app-grey-40 font-inter">Today</h3>
              </div>
              <div className="mt-4">
                <AppToggleButton
                  isToggled={showInternalMeetingsOnly}
                  toggleButtonHandler={handleToggle}
                  size="small"
                  showDefaultLabel={true}
                  label="GoTackle Meetings Only"
                />
              </div>
            </div>
          )}
          <div className="mt-8">
            <AppFutureEvents
              calendarEventViewPreference={
                showInternalMeetingsOnly ? CalendarEventViewPreference.Internal : ''
              }
              role={(currentUser?.roles ?? []) as string[]}
              showInternalMeetingsOnly={showInternalMeetingsOnly}
            />
          </div>
        </AppDashboardGridItemWrapper>
      </div>
      <AppDashboardStatsSummary />
    </div>
  )
}

export default AppDashboard
